export function getView(signup_confirm_request) {
  return signup_confirm_request.contact_methods.length > 1
    ? signup_confirm_request.can_request_new_code
      ? 'Content'
      : 'PleaseWait'
    : 'No'
}
